import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Use this for navigation
import StepBar from "../utils/StepBar";
import SliderButton from "../utils/SliderButton";
import SelectorButton from "../utils/SelectorButton";
import devLogo from "../../images/devlogo.png";
import fullstack from "../../images/devlogo2.png";
import jslogo from "../../images/js logo.png";
import cybersec from "../../images/cybersecurity.png";
import datascience from "../../images/datascience.png";
import python from "../../images/python.png";
import webdesign from "../../images/webdesign.png";
import ai from "../../images/AI.png";
import digitalmarketing from "../../images/digitalmarketing.png";
import "./ApplicantLandingStepOne.css";

const ApplicantLandingStepOne = ({ applicant, setApplicant }) => {
  const [selectedProgram, setSelectedProgram] = useState("Bootcamps"); // Default selection
  const navigate = useNavigate(); // Use navigate for navigation

  const handleSliderToggle = (selectedLabel) => {
    setSelectedProgram(selectedLabel);
  };

  const handleProgramSelect = (programName) => {
    // Update the applicant object with the selected program
    const updatedApplicant = {
      ...applicant,
      program: programName,
    };
    setApplicant(updatedApplicant); // Update the applicant state

    // Navigate to step 2
    navigate("/applicant/step2");
  };

  return (
    <div
      className={`applicant-step-one-container ${
        selectedProgram === "Bootcamps"
          ? "bootcamp-background"
          : "career-booster-background"
      }`}
    >
      <div className="header-container">
        <img src={devLogo} alt="Dev Logo" className="dev-logo" />
        <h1 className="main-heading">Program Registration</h1>
      </div>
      <StepBar
        totalSteps={3}
        currentStep={1}
        labels={["Program Selection", "Personal Details", "Preferences"]}
      />
      <h2 className="sub-heading">Select Your Program</h2>

      <div className="slider-section">
        <SliderButton
          leftLabel="Bootcamps"
          rightLabel="Career Boosters"
          onToggle={handleSliderToggle}
          showHoverEffect={true}
          leftHoverText="Programs designed to become a professional developer in 3 - 6 months, offered part and full time"
          rightHoverText="Specialized programs for professionals who want to boost their current careers with some top-tech skills. Programs offered part-time and after hours"
        />
      </div>

      <div className="divider-line"></div>

      <h3 className="selected-program-heading">{selectedProgram}</h3>

      <div className="selector-buttons-container">
        {selectedProgram === "Bootcamps" && (
          <>
            <SelectorButton
              imageSrc={fullstack}
              headerText="Certified Full-Stack Developer"
              subHeaderText="Learn Multiple Technologies and Become a Full-Stack Developer"
              hoverText="Click to learn more about Certified Full-Stack Developer"
              onClick={() =>
                handleProgramSelect("Certified Full-Stack Developer")
              }
            />
            <SelectorButton
              imageSrc={jslogo}
              headerText="Software Engineer: JavaScript"
              subHeaderText="Building Interactive Web Experiences from Front-End to Back-End"
              hoverText="Click to learn more about Software Engineer: JavaScript"
              onClick={() =>
                handleProgramSelect("Software Engineer: JavaScript")
              }
            />
            <SelectorButton
              imageSrc={python}
              headerText="Software Engineer: Python"
              subHeaderText="From Problem-Solving Algorithms to Real-World Web Applications"
              hoverText="Click to learn more about Software Engineer: Python"
              onClick={() => handleProgramSelect("Software Engineer: Python")}
            />
            <SelectorButton
              imageSrc={datascience}
              headerText="AI & Data Science Bootcamp"
              subHeaderText="From Data Mastery to AI-Driven Innovation"
              hoverText="Click to learn more about AI & Data Science Bootcamp"
              onClick={() => handleProgramSelect("AI & Data Science Bootcamp")}
            />
            <SelectorButton
              imageSrc={cybersec}
              headerText="Cybersecurity Defender Bootcamp"
              subHeaderText="Become a White Hat Hacker and Learn Modern Data Security Protocols"
              hoverText="Click to learn more about Cybersecurity Defender Bootcamp"
              onClick={() =>
                handleProgramSelect("Cybersecurity Defender Bootcamp")
              }
            />
          </>
        )}
        {selectedProgram === "Career Boosters" && (
          <>
            <SelectorButton
              imageSrc={webdesign}
              headerText="Web Design and Development Career Booster"
              subHeaderText="Creating Modern, Responsive Websites with Cutting-Edge Tools"
              hoverText="Click to learn more about Web Design and Development Career Booster"
              onClick={() =>
                handleProgramSelect("Web Design and Development Career Booster")
              }
            />
            <SelectorButton
              imageSrc={ai}
              headerText="AI for Business Leaders Career Booster"
              subHeaderText="Empowering Strategic Innovation with AI Technologies"
              hoverText="Click to learn more about AI for Business Leaders Career Booster"
              onClick={() =>
                handleProgramSelect("AI for Business Leaders Career Booster")
              }
            />
            <SelectorButton
              imageSrc={digitalmarketing}
              headerText="Digital Marketing Career Booster"
              subHeaderText="Boost your career with Digital Marketing skills"
              hoverText="Click to learn more about Digital Marketing Career Booster"
              onClick={() =>
                handleProgramSelect("Digital Marketing Career Booster")
              }
            />
            <SelectorButton
              imageSrc={datascience}
              headerText="Data Driven Decision Making with Python"
              subHeaderText="Transform Data into Strategic Business Insights"
              hoverText="Click to learn more about Data Driven Decision Making with Python"
              onClick={() =>
                handleProgramSelect("Data Driven Decision Making with Python")
              }
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ApplicantLandingStepOne;
